// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-435e95d1] {\n  font-weight: normal;\n  line-height: 1.15;\n}\n.sub-radio-dot[data-v-435e95d1] {\n  font-size: 0.875rem !important;\n}\n.card-title[data-v-435e95d1] {\n  margin-bottom: 0;\n}\n.selected[data-v-435e95d1] {\n  border: 1px solid var(--brand-400);\n  background: white;\n  box-shadow: 0px 0px 10px var(--brand-400);\n}\n", ""]);
// Exports
module.exports = exports;
